import Base from 'app/collections/base';
import TrackingDetail from 'app/models/tracking_detail';

export default Base.extend({
  model: TrackingDetail,
});



// WEBPACK FOOTER //
// ./app/collections/tracking_details.js